import { render, staticRenderFns } from "./platticketrecordqy.vue?vue&type=template&id=26262240&scoped=true&"
import script from "./platticketrecordqy.vue?vue&type=script&lang=js&"
export * from "./platticketrecordqy.vue?vue&type=script&lang=js&"
import style0 from "./platticketrecordqy.vue?vue&type=style&index=0&id=26262240&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26262240",
  null
  
)

export default component.exports